import { hasAnyPermission } from "./permissionUtils";

export const filterMenuByPermissions = (menu, userPermissions) => {
    return menu
        .map((item) => {
            const children = filterMenuByPermissions(
                item?.children || [],
                userPermissions
            );

            const hasPermission = hasAnyPermission(
                userPermissions,
                item.requiredPermissions || []
            );

            if (hasPermission || children.length > 0) {
                return {
                    ...item,
                    children
                };
            }

            return null;
        })
        .filter(Boolean);
};
